import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { OIDCProvider } from '../../../../shared/model-typings/oidcprovider';

/**
 * Fetch a single OIDC provider by ID.
 */
function fetchOIDCProvider(providerId: number) {
  return get<OIDCProvider>(`/api/oidc/providers/${providerId}`);
}

/**
 * Query key for caching and invalidation.
 */
const getQueryKey = (providerId: number): QueryKey => ['oidc-provider', providerId];

/**
 * Hook to fetch a single OIDC provider by ID.
 */
export default function useOIDCProvider(providerId: number, shouldFetch: boolean = true) {
  return useQuery<OIDCProvider>({
    queryKey: getQueryKey(providerId),
    queryFn: () => fetchOIDCProvider(providerId),
    enabled: shouldFetch,
    staleTime: 20 * 60 * 1000, // 20 minutes; it is not possible to update a provider so the data should never change
  });
}
